module.exports = __webpack_public_path__ + "media/images/pc/stores/common/instagram/hairmake_sns_05-b5bf11523425ebaf9d0c9c08ba773871.jpg";